import { AxiosResponse } from 'axios';
import adminApi from './adminApi';
import type { EventSession, CreateEventRequest, UpdateEventRequest } from '../types';

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}

export const eventApi = {
  // Get all events
  getAllEvents: (): Promise<AxiosResponse<ApiResponse<EventSession[]>>> => {
    return adminApi.get('/event-sessions');
  },

  // Get event by ID
  getEventById: (id: string): Promise<AxiosResponse<ApiResponse<EventSession>>> => {
    return adminApi.get(`/event-sessions/${id}`);
  },

  // Create new event
  createEvent: (data: CreateEventRequest): Promise<AxiosResponse<ApiResponse<EventSession>>> => {
    return adminApi.post('/event-sessions', data);
  },

  // Update event
  updateEvent: (id: string, data: UpdateEventRequest): Promise<AxiosResponse<ApiResponse<EventSession>>> => {
    return adminApi.put(`/event-sessions/${id}`, data);
  },

  // Delete event
  deleteEvent: (id: string): Promise<AxiosResponse<ApiResponse<void>>> => {
    return adminApi.delete(`/event-sessions/${id}`);
  },

  // Activate event
  activateEvent: (id: string): Promise<AxiosResponse<ApiResponse<EventSession>>> => {
    return adminApi.post(`/event-sessions/${id}/activate`);
  },

  // Deactivate event
  deactivateEvent: (id: string): Promise<AxiosResponse<ApiResponse<EventSession>>> => {
    return adminApi.post(`/event-sessions/${id}/deactivate`);
  },

  // End event
  endEvent: (id: string): Promise<AxiosResponse<ApiResponse<EventSession>>> => {
    return adminApi.post(`/event-sessions/${id}/end`);
  },

  // Get QR token (for testing)
  getQRToken: (sessionId: string): Promise<AxiosResponse<ApiResponse<{
    token: string;
    qrCodeDataUrl: string;
    timeRemaining: number;
  }>>> => {
    return adminApi.get(`/events/qr-token/${sessionId}`);
  },

  // Get event session details (public)
  getEventSessionDetails: (sessionId: string): Promise<AxiosResponse<ApiResponse<EventSession>>> => {
    return adminApi.get(`/events/session/${sessionId}`);
  },

  // Generate QR token for display
  generateQRToken: (sessionId: string): Promise<AxiosResponse<ApiResponse<{
    token: string;
    timeRemaining: number;
  }>>> => {
    return adminApi.post(`/event-sessions/${sessionId}/generate-token`);
  }
};
